export const infos = [{
    user_id: 1,
    template_code: 'T001',
    titles: ["向新而行", "MOVING TOWARDS THE NEW AND CREATING THE FUTURE"],
    specialty_short: ["高端化", "国际化", "专业化", "市场化", "智能化"],
    specialty: ["未来高新科技·未来智能"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div1-center.png"),
    //image:"https://gips3.baidu.com/it/u=1821127123,1149655687&fm=3028&app=3028&f=JPEG&fmt=auto?w=720&h=1280"，
    index: 0
},
{
    user_id: 1,
    template_code: 'T002',
    titles: ["非标定制加工"],
    specialty_short: ["厂家直供", "来图来样", "品质放心"],
    specialty: ["采用的是精密制造的轴承钢材，比其他品类轴承材质更耐用耐磨", "17年行业经验专注五金加工"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div2-center.png"),
    index: 0
},
{
    user_id: 1,
    template_code: 'T003',
    titles: ["激擎燃动", "", "战力全开", ""],
    specialty: ["搭载智慧引擎，一睹前端科技", "引领炫目风潮畅享驾驶体验"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div3-center.png"),
    index: 0
},
{
    user_id: 1,
    template_code: 'T004',
    titles: ["科技创新赋能变革"],
    specialty: ["深入探讨 权威解读"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div4-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T005',
    titles: ["八大核心技术"],
    specialty: ["快人不止这一点", "关注好礼送不停"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div5-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T006',
    titles: ["性价比之选", "", "精品黄铜球阀", ""],
    specialty: ["6大优势，品质保障"],
    specialty_short: ["保质保量", "耐腐耐磨"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div6-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T007',
    titles: ["高品质风机", "", "源自精心选材", ""],
    specialty: ["精心铸造·匠心品质", "冷轧矽钢片+高精度转子+耐高温轴承", "离心风机的动力之源，强劲性能持续输出"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div7-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T008',
    titles: ["驾驶式洗地机"],
    specialty: ["绿色环保无污染", "0排放、0污染，对环境无伤害"],
    specialty_short: ["紧凑灵巧", "操作简单"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div8-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T009',
    titles: ["一站式采购"],
    specialty: ["品质可靠 专注行业多年"],
    specialty_short: ["种类齐全", "种类齐全", "现货充足", "量大优惠"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div9-center.png"),
    index: 0
}, {
    user_id: 1,
    template_code: 'T010',
    titles: ["混凝土砖墙"],
    specialty: ["你随意 大小孔我都行", "世界工具品牌", "百年工具 成就匠心"],
    specialty_short: ["焕新而来", "十大升级"],
    company: "浙江省杭州市xx科技股份有限公司",
    image: require("../img/div10-center.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T011',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T012',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T013',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T014',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T015',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T016',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T017',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T018',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T019',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
    , {
    user_id: 1,
    template_code: 'T020',
    titles: ["生产型企业", "该不该做短视频营销"],
    image: require("../img/div11-20-bg.png"),
    index: 0
}
]
export default { infos }